<template>
  <div id="app">
    <van-image
      width="100%"
      height="100%"
      fit="contain"
      style="margin-bottom: 20px;"
      :src="logoPath"
    />
    <van-form @submit="onSubmit">
      <van-field
        v-model="postForm.mobile"
        required
        label="手机号"
        placeholder="请输入手机号"
        :rules="[{ required: true, message: '请填写用户名' }]"
      />
      <van-field
        v-model="postForm.code"
        center
        clearable
        label="验证码"
        placeholder="请输入"
      >
        <template #button>
          <van-button size="small" type="primary" native-type="button" @click="sendCode">{{ sendBtnText }}</van-button>
        </template>
      </van-field>
      <div style="margin: 20px;">
        <van-button round block type="info" native-type="submit">注册</van-button>
        <van-button round block type="info" style="margin-top: 10px;" native-type="button" @click="forwardLogin">返回登录</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>

import {Toast} from 'vant'
import {sendRegisterCode, bindMobile} from '@/api/user'

export default {
  name: 'register',
  data () {
    return {
      postForm: {
        mobile: '',
        openid: '',
        unionid: '',
        code: ''
      },
      // 是否已经发送了验证码
      isSmsSend: false,
      // 文本
      sendBtnText: '点击发送验证码',
      // 计时器对象
      timer: null,
      // 倒数60秒
      counter: 60,
      logoPath: require('../../assets/logo.png'),
      code: '',
    }
  },
  created() {
  },
  methods: {
    sendCode () {
      if (this.postForm.mobile === '' || typeof this.postForm.mobile === 'undefined') {
        Toast('手机号不可为空')
        return false
      }
      if (this.postForm.mobile.length !== 11) {
        Toast('手机号不正确')
        return false
      }
      if (!this.isSmsSend) {
        sendRegisterCode(this.postForm).then((res) => {
          Toast('短信发送成功')
          this.isSmsSend = true
          this.countDown()
        })
      }
    },
    countDown () {
      // 将setInterval()方法赋值给前面定义的timer计时器对象，等用clearInterval()方法时方便清空这个计时器对象
      this.timer = setInterval(() => {
        // 替换文本，用es6里面的``这个来创建字符串模板，让秒实时改变
        this.sendBtnText = `(${this.counter}秒)后重新发送`
        this.counter--
        if (this.counter < 0) {
          // 当计时小于零时，取消该计时器
          clearInterval(this.timer)
          this.reset()
        }
      }, 1000)
    },
    reset () {
      // 重置按钮可用
      this.isSmsSend = false
      // 重置文本内容
      this.sendBtnText = '点击发送验证码'
      if (this.timer) {
        // 存在计时器对象，则清除
        clearInterval(this.timer)
        // 重置秒数，防止下次混乱
        this.counter = 60
        // 计时器对象重置为空
        this.timer = null
      }
    },
    forwardLogin() {
      this.$router.push({path: '/'})
    },
    onSubmit () {
      if (this.postForm.code === '' || typeof this.postForm.code === 'undefined') {
        Toast('缺少短信验证码')
        return false
      }
      const openId = localStorage.getItem('openid')
      if (openId === null || openId === '' || typeof openId === 'undefined') {
        Toast('请在微信端授权使用')
        return false
      }
      this.postForm.openid = openId
      bindMobile(this.postForm).then((res) => {
        if (res.data.token) {
          Toast('注册成功')
          localStorage.setItem('token', (res.data.type ? res.data.type : 'Bearer') + ' ' + res.data.token)
          this.$router.push('/')
        }
      })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/views/user/register.vue